<template>
  <div>
    <el-row>
      <el-col :sm="{span: 12, offset: 6}">
        <img class="image" src="@/assets/images/Droplii_logo-green.png">
      </el-col>
    </el-row>
    <el-row align="middle" type="flex" justify="center">
      <el-col v-loading="!mentor" :sm="{span: 12}" :lg="{span: 8}">
        <div class="star-left">
          <img class="star-size" src="@/assets/images/starLeft.png" alt="">
        </div>
        <el-card v-if="mentor">
          <br>
          <b slot="header">Best Day EVER!</b>
          <div>
            <b>Your Friend</b>
            <h1>
              <a>{{` ${mentor.FirstName} ${mentor.LastName || ''}`}}</a>
            </h1>
            <p>Has invited you to join Droplii! Complete the Signup below to receive free access to your online and mobile oil guide!</p>
          </div>
        </el-card>
        <div class="card">
          <img class="star star-size" src="@/assets/images/starRight.png" alt="">
        </div>
      </el-col>
    </el-row>
    <br>
    <el-row align="middle" type="flex" justify="center">
      <el-col :sm="{span: 12}" :lg="{span: 8}">
        <el-card class="box-card">
          <signup-form v-if="!signUpSuccess" @signup="onSignup"/>
          <download-go v-else/>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import LoginForm from '@/components/auth/LoginForm'
import SignupForm from '@/components/auth/SignupForm'
import DownloadGo from '@/components/auth/DownloadGo'
import { mapGetters } from 'vuex'
import { HTTP } from '@/http-common'
export default {
  data() {
    return {
      mentor: null,
      signUpSuccess: false
    }
  },
  computed: {
    ...mapGetters(['signUpStep', 'checkoutLink'])
  },
  methods: {
    onSignup(user) {
      const signupUser = Object.assign(
        { MentorCode: this.mentor.MentorCode },
        user
      )
      this.$store
        .dispatch('signUpShared', signupUser)
        .then(() => (this.signUpSuccess = true))
    }
  },
  components: {
    LoginForm,
    SignupForm,
    DownloadGo
  },
  async created() {
    const query = this.$route.query
    if (query.m) {
      const response = await HTTP.get('mentors/lookup/' + query.m)
      this.mentor = response.data
    }
  }
}
</script>

<style scoped>
.image {
  max-width: 30%;
}
.star-left {
  position: relative;
  width: 100px;
  height: 100px;
  margin: -50px;
  z-index: 1;
  left: 20px;
  top: 50px;
}
.star-right {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 200px;
  height: 100px;
}
.star {
  position: absolute;
  right: -5px;
  top: -50px;
}
.card {
  position: relative;
  z-index: 1;
}
.star-size {
  max-width: 50px;
}
</style>

